import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';

export default class ClientAppRoute extends Route {
  @service analytics;

  queryParams = {
    'client_id': { refreshModel: false },
    'profile_id': { refreshModel: false },
    'document_id': { refreshModel: false },
    page: { refreshModel: false },
  };

  beforeModel(transition) {
    const queryParams = transition.to.queryParams;
    this.analytics?.trackAnonymously?.('Client App Route Accessed', {
      object: 'Client App Route',
      action: 'Accessed',
      source: 'universal-link-fallback',
      page: queryParams.page,
      'client_id': queryParams.client_id,
      'profile_id': queryParams.profile_id,
      'document_id': queryParams.document_id,
    });
  }
}
